import React from 'react';

import './style.scss';

const RoundCheckbox = ({ label, ...rest }) => {
    return <React.Fragment>
        <input
            type="checkbox"
            className="round-checkbox__input"
            id="roundCheckbox"
            name="roundCheckbox"
            {...rest}
        />
        <label className="round-checkbox__label" htmlFor="roundCheckbox">{label}</label>
    </React.Fragment>;
};

export default React.memo(RoundCheckbox);